export default "__VITE_ASSET__SRIJw76B__"